import messages from './admin.json' with { type: 'json' };

export const adminEn: Readonly<typeof messages> = messages;
